/**
 * Formats a change-log value (a line item's yearly total) the way the line item Change log shows it:
 * plain number, thousands separators, 2 decimals, no currency (count lines like Rooms share the column).
 *
 * @param {number|string|null|undefined} value
 * @returns {string} formatted value, or "-" when there is none
 */
const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * 202601 → "Jan 2026" (withYear) or "Jan".
 *
 * @param {number} yearMonth - year * 100 + month
 * @param {boolean} [withYear=true]
 */
export const formatYearMonth = (yearMonth, withYear = true) => {
  const month = MONTH_NAMES[(yearMonth % 100) - 1];
  if (!month) return String(yearMonth ?? "-");
  return withYear ? `${month} ${Math.floor(yearMonth / 100)}` : month;
};

export const formatChangeLogValue = (value) => {
  const number = parseFloat(value);
  if (value === null || value === undefined || isNaN(number)) return "-";
  return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
